import RouterView from './index.vue';

export {
    RouterView,
};

export default RouterView;
